import { TRANSPARENT_PIXEL, type CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';

export interface EmptySlotOpts {
  width?: number;
  height?: number;
}

export function buildEmptySlot(opts: EmptySlotOpts = {}): CanvasJSONLikeObject {
  return {
    type: 'Image',
    version: '7.1.0',
    src: TRANSPARENT_PIXEL,
    crossOrigin: 'anonymous',
    originX: 'center',
    originY: 'center',
    left: 0,
    top: 0,
    width: opts.width ?? 80,
    height: opts.height ?? 80,
    scaleX: 1,
    scaleY: 1,
    visible: false,
    selectable: true,
    evented: true,
    objectCaching: false
  };
}
